import { render, staticRenderFns } from "./TransactionGlanceComponent.vue?vue&type=template&id=613f5c31"
import script from "./TransactionGlanceComponent.vue?vue&type=script&lang=js"
export * from "./TransactionGlanceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports